import { css } from "../helpers/webComponents";
import { htmlArray } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { Page } from "../enums/Page";

const styles: string = css`
    .confirm-dialog {
        position: fixed; 
        top: 0; left: 0; right: 0; bottom: 0;
        background-color: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .confirm-dialog-inner {
        text-align: center;
        background-color: white;
        padding: 25px;
        border-radius: 10px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
        width: 350px;
        font-size: 18px;
    }

    .confirm-dialog-inner p {
        color: black; /* Tekstkleur zwart gemaakt */
    }

    .button-container {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }
    .confirm-dialog button {
        flex: 1;
        margin: 0 10px;
        padding: 10px;
        font-size: 16px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        transition: background 0.3s ease;
    }
    #confirmYes {
        background-color: #d9534f;
        color: white;
    }
    #confirmYes:hover {
        background-color: #c9302c;
    }
    #confirmNo {
        background-color: #5bc0de;
        color: white;
    }
    #confirmNo:hover {
        background-color: #46b8da;
    }
`;

export class UitlogMessageComponent extends HTMLElement {
    private _gameEventService: GameEventService = new GameEventService();

    public constructor() {
        super();
        this.attachShadow({ mode: "open" });
    }

    public connectedCallback(): void {
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) return;

        const elements: HTMLElement[] = htmlArray`
            <style>${styles}</style>
            <div class="confirm-dialog">
                <div class="confirm-dialog-inner">
                    <p>Weet je zeker dat je wilt uitloggen?</p>
                    <div class="button-container">
                        <button id="confirmYes">Ja</button>
                        <button id="confirmNo">Nee</button>
                    </div>
                </div>
            </div>
        `;

        this.shadowRoot.innerHTML = "";
        this.shadowRoot.append(...elements);

        this.addEventListeners();
    }

    private addEventListeners(): void {
        this.shadowRoot?.querySelector("#confirmYes")?.addEventListener("click", () => {
            this.handleLogout();
        });

        this.shadowRoot?.querySelector("#confirmNo")?.addEventListener("click", () => {
            this._gameEventService.switchPage(Page.Canvas);
        });
    }

    private handleLogout(): void {
        localStorage.removeItem("userId");
        localStorage.removeItem("playerSessionId");
        localStorage.removeItem("isLoggedIn");
        this._gameEventService.switchPage(Page.Auth);
    }
}
